const state = {
  current_tab: '维护',
  show_help: false
};

const getters = {
};

const actions = {

};

const mutations = {
  changeTab(state, tab) {
    state.current_tab = tab
  },
  changeHelp(state, visible) {
    state.show_help = visible;
  }
};


export default {
  namespaced: true, //  module 命名空间，以后在引用的时候都需要用到文件名/action 或者 mutations 或者 state
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/tab.js